<ng-container *ngIf="user.imageUrl !== null; else defaultInitials">
    <ng-container *ngIf="!user.privateProfile; else privateProfile">
            <img [src]="user.imageUrl" />
    </ng-container>
</ng-container>
<ng-template #defaultInitials>
    <div class="circle-initials">
        <span>{{user.firstName.charAt(0)}}</span>
        <span>{{user.lastName.charAt(0)}}</span>
    </div>
</ng-template>
<ng-template #privateProfile>
    <img src="assets/img/private-user.png" />
</ng-template>
